import { Row, Col, Checkbox } from "antd";
import Title from "antd/lib/typography/Title";
import React from "react";
import { TTranslate } from "../../../../core/service/locale/TranslationService";
import { CollectionTypes } from "../../../common/Constants";

const CheckboxGroup = Checkbox.Group;



const defaultCollectionTypes = [
  CollectionTypes.STAV,
  CollectionTypes.ODLUKA,
  CollectionTypes.PRAVNO_SHVATANJE
];

const CollectionCheckboxGroup = ({
  onSelectionChanged, translate
}: {
  translate: TTranslate,
  onSelectionChanged: (selectedItems: string[]) => any;
}) => {

  const collectionTypes = [
    { value: CollectionTypes.STAV, label: translate("search.collection.stav") },
    { value: CollectionTypes.ODLUKA, label: translate("search.collection.odluka") },
    { value: CollectionTypes.PRAVNO_SHVATANJE, label: translate("search.collection.pravno_shvatanje") }
  ];

  const [selectedCollectionTypes, setCheckedList] = React.useState(
    defaultCollectionTypes
  );
  const [indeterminate, setIndeterminate] = React.useState(false);
  const [checkAll, setCheckAll] = React.useState(true);

  React.useEffect(() => {
    onSelectionChanged(defaultCollectionTypes);
  }, []);

  const onChange = (list) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < collectionTypes.length);
    setCheckAll(list.length === collectionTypes.length);
    onSelectionChanged(list);
  };

  const onCheckAllChange = (e) => {
    const checkedList = e.target.checked
      ? collectionTypes.map((item) => item.value)
      : [];
    setCheckedList(checkedList);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
    onSelectionChanged(checkedList);
  };

  return (
    <Row className={"search-group"} style={{ minHeight: 80 }} align="middle">
      <Col xs={24} sm={6}>
        <Title level={2} className={"search-group-title"}>
          {translate("search.advanced.collection")}
        </Title>
      </Col>

      <Col sm={24} md={18}>
        <div className={"png-checkbox-group-horizontal"}>
          <Row>
            <Col sm={4}>
              <Checkbox
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}
              >
                {translate("search.advanced.collection_all")}
              </Checkbox>
            </Col>
            <Col sm={18}>
              <CheckboxGroup
                options={collectionTypes}
                value={selectedCollectionTypes}
                onChange={onChange}
              />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default CollectionCheckboxGroup;
